import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { CurrencyProps } from 'models/reusable-parts/currency';
import { wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsStandardizedDate from 'ui-elements/common-elements/FsStandardizedDate';
import FsBody from 'ui-elements/typography/FsBody';
import FsLink from 'ui-elements/links/FsLink';
import { useAppContext } from 'contexts/AppContext';
import {
  Currency,
  ErrorBox,
  ErrorCaption,
  PayButton,
  CurrencyBox,
  DateBox,
  LinkBox,
  RowBox,
} from './InvoiceSingleRow.style-elements';
import { getMessage } from './InvoiceSingleRow.utils';

export interface InvoiceSingleRowDataProps {
  id: number;
  date: number;
  amount: CurrencyProps;
  url: string;
  isPaid: boolean;
}

const InvoiceSingleRow: React.FC<InvoiceSingleRowDataProps> = ({
  id,
  date,
  isPaid,
  amount,
  url,
}) => {
  const {
    setIsPaymentMethodIssue,
    invoiceHistory: { update: updateStore },
  } = useAppContext();
  const [pending, setPending] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = async () => {
    setPending(true);
    await wait(1000);
    setPending(false);
    // eslint-disable-next-line no-console
    console.log('SEND', id);
    await updateStore();
    setIsPaymentMethodIssue(false);
    enqueueSnackbar(getMessage(date), {
      variant: 'success',
    });
  };

  return (
    <RowBox isPaid={isPaid}>
      <DateBox>
        {isPaid ? (
          <FsStandardizedDate>{date}</FsStandardizedDate>
        ) : (
          <ErrorBox>
            <ErrorCaption>{defaultLocales.unpaid}</ErrorCaption>
            <FsStandardizedDate>{date}</FsStandardizedDate>
          </ErrorBox>
        )}
      </DateBox>
      <CurrencyBox>
        {isPaid ? (
          <Currency format={amount.format} currency={amount.currency}>
            {amount.value}
          </Currency>
        ) : (
          <ErrorBox>
            <Currency format={amount.format} currency={amount.currency}>
              {amount.value}
            </Currency>
          </ErrorBox>
        )}
      </CurrencyBox>
      <LinkBox>
        <FsBody>
          <FsLink to={url}>{defaultLocales.pdf}</FsLink>
        </FsBody>
      </LinkBox>
      {!isPaid && (
        <PayButton pending={pending} onClick={handleClick}>
          {defaultLocales.payNow}
        </PayButton>
      )}
    </RowBox>
  );
};

export default InvoiceSingleRow;
